/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSpendRuleActorAttributesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSpendRuleActorAttributesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSpendRuleActorAttributesSecurity = {
  option1?: ListSpendRuleActorAttributesSecurityOption1 | undefined;
  option2?: ListSpendRuleActorAttributesSecurityOption2 | undefined;
};

export type ListSpendRuleActorAttributesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListSpendRuleActorAttributesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSpendRuleActorAttributesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListSpendRuleActorAttributesSecurityOption1$Outbound,
    ListSpendRuleActorAttributesSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listSpendRuleActorAttributesSecurityOption1ToJSON(
  listSpendRuleActorAttributesSecurityOption1:
    ListSpendRuleActorAttributesSecurityOption1,
): string {
  return JSON.stringify(
    ListSpendRuleActorAttributesSecurityOption1$outboundSchema.parse(
      listSpendRuleActorAttributesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSpendRuleActorAttributesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSpendRuleActorAttributesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListSpendRuleActorAttributesSecurityOption2$Outbound,
    ListSpendRuleActorAttributesSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listSpendRuleActorAttributesSecurityOption2ToJSON(
  listSpendRuleActorAttributesSecurityOption2:
    ListSpendRuleActorAttributesSecurityOption2,
): string {
  return JSON.stringify(
    ListSpendRuleActorAttributesSecurityOption2$outboundSchema.parse(
      listSpendRuleActorAttributesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSpendRuleActorAttributesSecurity$Outbound = {
  Option1?: ListSpendRuleActorAttributesSecurityOption1$Outbound | undefined;
  Option2?: ListSpendRuleActorAttributesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSpendRuleActorAttributesSecurity$outboundSchema: z.ZodMiniType<
  ListSpendRuleActorAttributesSecurity$Outbound,
  ListSpendRuleActorAttributesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSpendRuleActorAttributesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSpendRuleActorAttributesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSpendRuleActorAttributesSecurityToJSON(
  listSpendRuleActorAttributesSecurity: ListSpendRuleActorAttributesSecurity,
): string {
  return JSON.stringify(
    ListSpendRuleActorAttributesSecurity$outboundSchema.parse(
      listSpendRuleActorAttributesSecurity,
    ),
  );
}

/** @internal */
export type ListSpendRuleActorAttributesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSpendRuleActorAttributesRequest$outboundSchema: z.ZodMiniType<
  ListSpendRuleActorAttributesRequest$Outbound,
  ListSpendRuleActorAttributesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSpendRuleActorAttributesRequestToJSON(
  listSpendRuleActorAttributesRequest: ListSpendRuleActorAttributesRequest,
): string {
  return JSON.stringify(
    ListSpendRuleActorAttributesRequest$outboundSchema.parse(
      listSpendRuleActorAttributesRequest,
    ),
  );
}
